import React from 'react';
import { CheckCircle, Clock } from 'lucide-react';

const PlayedTracksHistory = ({ tracks = [] }) => {
  if (tracks.length === 0) {
    return (
      <div className="text-sunset-orange/50 text-sm text-center py-4">
        Aucun titre joué pour le moment
      </div>
    );
  }

  // Format time (HH:MM)
  const formatTime = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  };

  // Format duration (MM:SS)
  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="space-y-2">
      {tracks.map((track, index) => (
        <div
          key={`${track.id}-${index}`}
          className="p-2 rounded-lg border bg-dark-input/30 border-green-500/20"
        >
          <div className="flex items-start gap-2">
            <CheckCircle className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" />
            
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium truncate">{track.title}</p>
              <p className="text-sunset-orange/60 text-xs truncate">{track.artist}</p>
              
              <div className="flex items-center gap-2 mt-1">
                {track.playedAt && (
                  <div className="flex items-center gap-1 text-xs text-green-300/60">
                    <Clock className="w-3 h-3" />
                    <span>{formatTime(track.playedAt)}</span>
                  </div>
                )}
                {(track.duration_seconds || track.duration) && (
                  <span className="text-xs text-sunset-orange/40">
                    {formatDuration(track.duration_seconds || track.duration)}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(PlayedTracksHistory);
